// extracted by mini-css-extract-plugin
export default {"customFilterMultiselect":"customFilterMultiselect__nz2y_","filtersGrid":"filtersGrid__pkeaj"};